import { defineMessages } from 'react-intl';

const trns = defineMessages({
  homeBreadCrumb: {
    id: '/YV5ee',
    defaultMessage: 'Головна'
  },
  whoCanUse: {
    id: 'tNu/TF',
    defaultMessage: 'Кому можна'
  },
  specialties: {
    id: 'N0JEEU',
    defaultMessage: 'Особливості'
  },
  descriptionTab: {
    id: 'm7BuqO',
    defaultMessage: 'Опис'
  },
  aboutProduct: {
    id: 'onhKTE',
    defaultMessage: 'Все про товар'
  },
  pricesTab: {
    id: '6w/bbW',
    defaultMessage: 'Ціни в аптеках'
  },
  instructionsTab: {
    id: 'nUOiFb',
    defaultMessage: 'Інструкція'
  },
  analogTab: {
    id: '+dac6n',
    defaultMessage: 'Аналоги'
  },
  reviewsTab: {
    id: '4lbkX/',
    defaultMessage: 'Відгуки {rates}'
  },
  instructionDisclaimer: {
    id: 'YlUMQr',
    defaultMessage:
      'Важливо! Ця інструкція із застосування є офіційною інструкцією виробника, затвердженою та наданою Державним реєстром лікарських засобів України. Ця інструкція представлена винятково з метою ознайомлення і не є підставою для самолікування. '
  },
  composition: {
    id: 'kx3JCA',
    defaultMessage: 'Склад'
  },
  overdose: {
    id: '6Ydc6R',
    defaultMessage: 'Передозування'
  },
  sideEffects: {
    id: 'qsrN8U',
    defaultMessage: 'Побічні ефекти'
  },
  storageConditions: {
    id: '8rneJ3',
    defaultMessage: 'Умови зберігання'
  },
  maker: {
    id: 'W4PjS1',
    defaultMessage: 'Виробник'
  },
  category: {
    id: 'YlV5s4',
    defaultMessage: 'Категорія'
  },
  component: {
    id: 'tA5ioy',
    defaultMessage: 'Активні речовини'
  },
  forAllergic: {
    id: 'DRSmTk',
    defaultMessage: 'АЛЕРГІКАМ'
  },
  forDiabetic: {
    id: 'NanPJk',
    defaultMessage: 'ДІАБЕТИКАМ'
  },
  forDrivers: {
    id: '+bkz+6',
    defaultMessage: 'ВОДІЯМ'
  },
  forMothers: {
    id: 'ce3PkU',
    defaultMessage: 'ГОДУЮЧИМ МАТЕРЯМ'
  },
  forPregnant: {
    id: 'iGn22G',
    defaultMessage: 'Вагітним'
  },
  forChildren: {
    id: 'ASRo2P',
    defaultMessage: 'ДІТЯМ'
  },
  storageTemperature: {
    id: 'ZWbQ7C',
    defaultMessage: 'ТЕМПЕРАТУРА ЗБЕРІГАННЯ'
  },
  withAlcohol: {
    id: 'b8/K9u',
    defaultMessage: 'ВЗАЄМОДІЯ З АЛКОГОЛЕМ'
  },
  withRecipe: {
    id: 'vPneDa',
    defaultMessage: 'РЕЦЕПТУРНИЙ ВІДПУСК'
  },
  catalogBreadCrumb: {
    id: 'FCddpq',
    defaultMessage: 'Каталог ліків'
  },
  doze: {
    id: 'LaUpWq',
    defaultMessage: 'Дозування'
  },
  makerCountry: {
    id: 'l5EV5d',
    defaultMessage: 'Країна-виробник'
  },
  tradeName: {
    id: 'Wi8tfa',
    defaultMessage: 'Торгова назва'
  },
  form: {
    id: '1Q0X/I',
    defaultMessage: 'Форма випуску'
  },
  expiration: {
    id: 'BS/inH',
    defaultMessage: 'Термін придатності'
  },
  quantityInPack: {
    id: '0alxwq',
    defaultMessage: 'Кількість в упаковці'
  },
  inputType: {
    id: 'VEtoT9',
    defaultMessage: 'Спосіб введення'
  },
  morionCode: {
    id: '9D1Mfo',
    defaultMessage: 'Код Моріон'
  },
  atx: {
    id: 'GMyv+g',
    defaultMessage: 'Код АТС/ATX'
  },
  packaging: {
    id: 'ACUXyu',
    defaultMessage: 'Упаковка'
  },
  instructionForm: {
    id: 'JzkYg3',
    defaultMessage: 'Лікарська форма'
  },
  pharmacodinamica: {
    id: 'SpfHWq',
    defaultMessage: 'Фармакодинаміка'
  },
  pharmacokinetiks: {
    id: 'jMHOyb',
    defaultMessage: 'Фармакокінетика'
  },
  pharmGroup: {
    id: 'emJDMI',
    defaultMessage: 'Фармакотерапевтична група'
  },
  interactions: {
    id: '6UEEvm',
    defaultMessage:
      'Взаємодія з іншими лікарськими засобами та інші види взаємодій'
  },
  reactionSpeed: {
    id: 'C+AiZB',
    defaultMessage:
      'Здатність впливати на швидкість реакції при керуванні автотранспортом або роботі з механізмами'
  },
  pregnancy: {
    id: 'tT+Sb0',
    defaultMessage: 'Застосування у період вагітності або годування груддю'
  },
  children: {
    id: 'xzzI9g',
    defaultMessage: 'Діти'
  },
  indications: {
    id: 'uTNAqx',
    defaultMessage: 'Показання'
  },
  contraindications: {
    id: '8U8/p/',
    defaultMessage: 'Протипоказання'
  },
  application: {
    id: 'E2YMWi',
    defaultMessage: 'Спосіб застосування та дози'
  },
  description: {
    id: 'm7BuqO',
    defaultMessage: 'Опис'
  },
  priceInStoresLabel: {
    id: 'tQ2Un/',
    defaultMessage: 'Ціна в аптеках:'
  },
  notInStock: {
    id: 'qENd0c',
    defaultMessage: 'Немає в наявності'
  },
  economyLabel: {
    id: 'Tka+TR',
    defaultMessage: '*Економія при броні з LikiE {discount} ₴ '
  },
  foundIn: {
    id: 'M9maLM',
    defaultMessage: 'Знайдено в'
  },
  foundInStoresLabel: {
    id: 'X6BPmu',
    defaultMessage: '{count} аптеках'
  },
  checkAll: {
    id: '3KS51N',
    defaultMessage: 'Переглянути всі'
  },
  hide: {
    id: 'f/WfD8',
    defaultMessage: 'Згорнути'
  },
  instructionsFor: {
    id: 'nE/tEc',
    defaultMessage: 'Інструкція для {drugName}'
  },
  from: {
    id: 'gxdXfV',
    defaultMessage: 'від'
  },
  productToList: {
    id: 'B6DXKG',
    defaultMessage: 'Додайте товар у список, щоб обрати зручну аптеку'
  },
  notExist: {
    id: 'qENd0c',
    defaultMessage: 'Немає в наявності'
  },
  to: {
    id: 'aj0XRE',
    defaultMessage: 'до'
  },
  specificationsLabels: {
    id: 'xIW73K',
    defaultMessage: 'Характеристики'
  },
  relativeDoze: {
    id: 'r91Ucr',
    defaultMessage: 'ІНШІ ДОЗУВАННЯ'
  },
  relativePackage: {
    id: '7Lb8eg',
    defaultMessage: 'ІНШІ ФАСУВАННЯ'
  },
  activeComponent: {
    id: 'NkCieI',
    defaultMessage: 'Активної речовини: {doze}'
  },
  countLabel: {
    id: 'I2AKUA',
    defaultMessage: 'Кількість в упаковці: {count}'
  },
  addToList: {
    id: 'rdFtmG',
    defaultMessage: 'Додати у список'
  },
  storeFromLikiE: {
    id: 'jbjEwd',
    defaultMessage: 'аптека від'
  },
  fastCheckout: {
    id: 'v+gPfc',
    defaultMessage: 'Забронювати #швидкотут'
  },
  bestStoreLabel: {
    id: 'v5Nrh1',
    defaultMessage: 'Ми знайшли вигідну ціну в {bestStore} {near} з вами'
  },
  bestStore: {
    id: 'Dltvio',
    defaultMessage: 'аптеці'
  },
  near: {
    id: 'W/Gery',
    defaultMessage: 'поруч'
  },
  priceDependsLabel: {
    id: 'P1FXon',
    defaultMessage: 'Ціна залежить від обраної аптеки.'
  },
  discountAppliedOnlyLabel: {
    id: 'FmGcCD',
    defaultMessage: '* Знижка дійсна лише при оформленні броні на сайті LikiE'
  },
  schemaLabel1: {
    id: 'w+ySDl',
    defaultMessage: 'Знайдіть ліки за назвою або у {schemaLabel1SubLabel}'
  },
  schemaLabel1SubLabel: {
    id: 'Up7OYO',
    defaultMessage: 'каталозі ліків'
  },
  schemaLabel2: {
    id: 'Lf5C+D',
    defaultMessage: 'Додайте обраний товар до свого списку'
  },
  schemaLabel3: {
    id: '2jaM6g',
    defaultMessage: 'Оберіть аптеку і підтвердіть наявність'
  },
  schemaLabel4: {
    id: 'HMQPm9',
    defaultMessage: 'Оплачуйте і забирайте в аптеці замовлення'
  },
  fullAnalogue: {
    id: 'hpRFOc',
    defaultMessage: 'Повний аналог'
  },
  fullTradeNameAnalogue: {
    id: 'giYKMQ',
    defaultMessage: 'Повний аналог до товару «{tradeName}»'
  },
  otherFormAnalogue: {
    id: '1LWj6a',
    defaultMessage: 'Аналоги в інших формах випуску'
  },
  otherFormTradeNameAnalogue: {
    id: '9tW1u9',
    defaultMessage: 'Аналог до товару «{tradeName}» в іншій формі випуску'
  },
  sameEffectFormTradeNameAnalogue: {
    id: '7OjSUe',
    defaultMessage:
      'Аналоги до товару «{tradeName}» з подібним терапевтичним ефектом'
  },
  sameEffectFormAnalogue: {
    id: 'zNlUWo',
    defaultMessage: 'Подібний терапевтичний ефект'
  },
  analogueTitle: {
    id: 'snZvst',
    defaultMessage: 'Аналоги і замінники для {tradeName}'
  },
  fullAnalogueDesc: {
    id: 'lRM9eP',
    defaultMessage: 'Повний збіг складу діючих речовин'
  },
  sameEffectFormAnalogueDesc: {
    id: 'AzPdME',
    defaultMessage: 'Препарати входять в одну класифікаційну групу АТС'
  },
  good: {
    id: 'Nzqg1k',
    defaultMessage: 'Хороші'
  },
  homeDelivery: {
    id: 'gXeWiH',
    defaultMessage: 'з доставкою додому, що порадите?'
  },
  oftenBuy: {
    id: '/M8RbN',
    defaultMessage: 'Часто купують'
  },
  isCheap: {
    id: 'HSWXxL',
    defaultMessage: 'Є недорогі'
  },
  isInPharmacy: {
    id: 'bJulDg',
    defaultMessage: 'в аптеці у вас?'
  },
  isCheapGoods: {
    id: 'dzuR7O',
    defaultMessage: 'Так, є дешеві'
  },
  topGoods: {
    id: 'C/9EYo',
    defaultMessage: 'ТОП-3 недорогих товарів'
  },
  topCheapGoods: {
    id: 'gTbFNa',
    defaultMessage: 'наприклад, {topGoods}'
  },
  priceFrom: {
    id: 'nV4pck',
    defaultMessage: 'по ціні від'
  },
  canBuy: {
    id: 'j3LyXC',
    defaultMessage: 'Які можна купити'
  },
  withDiscount: {
    id: '2dIFya',
    defaultMessage: 'недорого зі знижкою'
  },
  canOrder: {
    id: 'MFFp1+',
    defaultMessage: 'Можна замовити'
  },
  canOrderOnline: {
    id: '0cvN6y',
    defaultMessage: 'з оплатою карткою онлайн на сайті'
  },
  yesCanBuy: {
    id: 'umWPDs',
    defaultMessage: 'Так, можна купити'
  },
  paymentMethods: {
    id: 'D6Kx+3',
    defaultMessage: 'онлайн. Детальніше про способи оплати в'
  },
  paymentPart: {
    id: 'vMFUEW',
    defaultMessage: 'розділі оплати'
  },
  inListLabel: {
    id: 'mqkiwz',
    defaultMessage: 'У списку товарів'
  },
  selectTheShop: {
    id: 'Zx8Koz',
    defaultMessage: 'Обрати аптеку'
  },
  openMapLabel: {
    id: 'JGvOO8',
    defaultMessage: 'На мапі'
  },
  proposalsTabLabel: {
    id: '9kYpt0',
    defaultMessage: 'Найкращі пропозиції аптек'
  },
  priceInCity: {
    id: 'wsJb+G',
    defaultMessage: 'Ціни у місті'
  },
  payAttention: {
    id: 'ldH5u/',
    defaultMessage: 'Зверніть увагу!'
  },
  instructionDescription: {
    id: 'fdLkkq',
    defaultMessage:
      'Інструкція, розміщена на цій сторінці, має інформаційний характер та\n' +
      '          призначена виключно для ознайомлення. Не використовуйте цю інструкцію\n' +
      '          в якості медичних рекомендацій. Постановлення діагнозу та вибору\n' +
      '          методики лікування здійснюються тільки вашим сімейним лікарем.\n' +
      '          Медмаркет LikiE не несе відповідальності за можливі негативні\n' +
      '          наслідки, виникщі в результати використання інформації, розміщеної на\n' +
      '          сайті likie.ua.'
  },
  moreDetails: {
    id: '1aiUC7',
    defaultMessage: 'Детальіше про'
  },
  denialOfResponsibility: {
    id: 'KTjpi4',
    defaultMessage: 'Відмова від відповідальності.'
  },
  priceDynamic: {
    id: '+0uNQn',
    defaultMessage:
      'Динаміка зміни середньої ціни на {drugName} в аптеках України'
  },
  leaveNewReview: {
    id: 'gh7f5e',
    defaultMessage: 'Залишити відгук'
  },
  priceTitle: {
    id: 'EPks3X',
    defaultMessage: 'Яка ціна на {drugName} ?'
  },
  priceContent: {
    id: 'dxr6nE',
    defaultMessage:
      'Ціна на препарат {drugName} в Україні від {minPrice} до {maxPrice}'
  },
  componentTitle: {
    id: 'avWSVN',
    defaultMessage: 'Яка діюча речовина у препарату {drugName}'
  },
  componentContent: {
    id: 'mSTjal',
    defaultMessage: 'Діючі речовини у {drugName} є {active}'
  },
  withRecipeTitle: {
    id: 'yaDzsr',
    defaultMessage: '{drugName} відпускається за рецептом?'
  },
  withRecipeContent: {
    id: 'kSE3uF',
    defaultMessage:
      '{drugName} є {prescriptionNeeded} препаратом, та відпускається {withPrescription}'
  },
  forDriversTitle: {
    id: 'WHCLNL',
    defaultMessage: 'Чи можна {drugName} приймати перед тим як сідати за кермо?'
  },
  forDriversContent: {
    id: 'Qp9bzY',
    defaultMessage: '{drugName} {allowed} приймати перед керуванням транспорту'
  },
  forPregnantTitle: {
    id: '+zMcJp',
    defaultMessage: 'Чи можна {drugName} приймати вагітним?'
  },
  forPregnantContent: {
    id: 'm8p/mt',
    defaultMessage: '{drugName} {allowed} приймати вагітним'
  },
  forMothersTitle: {
    id: 'DqgZJN',
    defaultMessage:
      'Чи можна {drugName} приймати під час грудного вигодовування?'
  },
  forMothersContent: {
    id: 'x9WXMy',
    defaultMessage:
      '{drugName} {allowed} приймати під час грудного вигодовування'
  },
  forAllergicTitle: {
    id: 'Z8EVJq',
    defaultMessage: 'Чи можна {drugName} приймати алергетикам ?'
  },
  forAllergicContent: {
    id: 'mMxovG',
    defaultMessage: '{drugName} {allowed} приймати алергетикам'
  },
  forDiabeticTitle: {
    id: 'Bj88i6',
    defaultMessage: 'Чи можна {drugName} приймати діабетикам  ?'
  },
  forDiabeticContent: {
    id: 'LXs5S4',
    defaultMessage: '{drugName} {allowed} приймати діабетикам '
  },
  storageTemperatureTitle: {
    id: 'YajFZl',
    defaultMessage: 'Яка температура для зберігання  {drugName} ?'
  },
  storageTemperatureContent: {
    id: '26koAd',
    defaultMessage:
      'Рекомендована температура для зберігання {drugName} {temperature} '
  },
  expirationTitle: {
    id: 'TIk1Vf',
    defaultMessage: 'Який термін зберігання {drugName} ?'
  },
  expirationContent: {
    id: 'uy8azs',
    defaultMessage: 'Рекомендований термін зберігання {drugName} {expiration}  '
  },
  askedQuestions: {
    id: 'k72U5y',
    defaultMessage: 'Часті запитання'
  },
  releasedWithRecipe: {
    id: 'FxtRTM',
    defaultMessage: 'рецептурним'
  },
  releasedWithoutRecipe: {
    id: 'zTmozE',
    defaultMessage: 'безрецептурним'
  },
  promo50uahDiscount: {
    id: 'N5KOkO',
    defaultMessage: 'Зроби замовлення на 500 грн та отримай знижку 50 грн'
  },
  promo50uahDetails: {
    id: 'Sytye5',
    defaultMessage: 'Детальіше'
  }
});

export default trns;
